import React from 'react';

export const SuccessCheckIcon: React.FC<sharedComponents.SvgIcon> = ({ width = 28, height = 28, className = '' }) => (
  <svg className={className} width={`${width}px`} height={`${height}px`} viewBox="0 0 28 28" fill="none">
    <path
      fill="#1B8811"
      d="M14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0ZM20.9 9.9L11.5 19.3L7.1 14.9C6.9 14.7 6.9 14.4 7.1 14.2C7.3 14 7.6 14 7.8 14.2L11.4 17.8L20 9.2C20.2 9 20.5 9 20.7 9.2C20.9 9.4 21 9.7 20.9 9.9Z"
    />
  </svg>
);
